import { render, staticRenderFns } from "./MediaDisplayer.vue?vue&type=template&id=09850ce9&scoped=true"
import script from "./MediaDisplayer.vue?vue&type=script&lang=js"
export * from "./MediaDisplayer.vue?vue&type=script&lang=js"
import style0 from "./MediaDisplayer.vue?vue&type=style&index=0&id=09850ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09850ce9",
  null
  
)

export default component.exports